var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"2.5","d":"M17 4h4v4m-1 3v3a3 3 0 0 1-3 3h-2l-3 3l-3-3H7a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h7m2 4l5-5"}));
}

Maximize.defaultProps = {"aria-hidden":"true","role":"img","width":"10","height":"15","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24"};

module.exports = Maximize;

Maximize.default = Maximize;
